var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Responsive: 4, 3, 2, 1")]),_c('vue-horizontal-list-autoscroll',{attrs:{"items":_vm.items,"options":_vm.options},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"item"},[_c('h3',[_vm._v(_vm._s(item.title))]),_c('p',[_vm._v(_vm._s(item.content))])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }